import type { ReactElement } from "react";
import ThreeDotsOverlay from "@/shared/components/generic/loading/ThreeDotsOverlay";
import { useThreeDotsOverlay } from "@/shared/components/generic/hooks/useThreeDotsOverlay.ts";

export default function GlobalThreeDotsOverlay(): ReactElement | undefined {
  const { isVisible } = useThreeDotsOverlay();
  return isVisible ? <ThreeDotsOverlay /> : undefined;
}
